import React from "react";
import { useNavigate } from "react-router-dom";
import { RectangleContainer } from "../atoms/rectangle-container";
import { ActionButtons } from "../atoms/action-buttons";
import { Button } from "../atoms/button";

interface SubmissionFailedProps {
  errorMessage?: string;
}

export const SubmissionFailed: React.FC<SubmissionFailedProps> = ({
  errorMessage = "An unexpected error occurred while processing your submission.",
}) => {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-lg mx-auto p-6 text-center space-y-4">
      {/* Icon */}
      <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-[rgba(239,68,68,0.3)] text-[rgba(239,68,68,1)]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="w-8 h-8"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>

      {/* Error Message */}
      <h1 className="text-2xl font-bold text-black">Submission Failed!</h1>
      <p className="text-dark-gray text-sm">{errorMessage}</p>

      {/* Action Buttons */}
      <Button type="primary" onClick={() => navigate("/")}>
        Return to task selection
      </Button>
    </div>
  );
};
